const initiateTagFilter = (wrapper) => {
  let currentPage = 1;

  const createClickEvents = () => {
    jQuery(".nav-posts-pages-row .nav-btn-page", wrapper)
      .unbind("click")
      .bind("click", (e) => {
        currentPage = jQuery(e.currentTarget).data("page");
        renderTableVisibility();
      });

    jQuery(".nav-posts-pages-row .nav-btn-next", wrapper)
      .unbind("click")
      .bind("click", (e) => {
        const maxPages = parseInt(jQuery(e.currentTarget).data("maxpages"));
        if (currentPage < maxPages) {
          currentPage = currentPage + 1;
          renderTableVisibility();
        }
      });
  };

  const renderTableVisibility = async () => {
    jQuery(".post-type-content-container", wrapper).addClass("hidden");
    jQuery(".post-type-loader", wrapper).removeClass("hidden");

    const tags = [];
    const category = jQuery("[name=category]", wrapper).val();
    const numberposts = jQuery("[name=numberposts]", wrapper).val();
    jQuery("[type=radio]:checked,[type=checkbox]:checked", wrapper).each(
      (idx, el) => {
        tags.push(jQuery(el).val());
      }
    );

    var data = new FormData();
    data.append("action", "loadPostsByArgs");
    data.append("tags", tags.join(","));
    data.append("category", category);
    data.append("numberposts", numberposts);
    data.append("page", currentPage);

    const response = await fetch(window.ajax.url, {
      method: "POST",
      body: data,
    });

    const text = await response.text();
    jQuery(".post-type-content-container", wrapper).html(text);
    jQuery(".post-type-content-container", wrapper).removeClass("hidden");
    jQuery(".post-type-loader", wrapper).addClass("hidden");
    jQuery(`.nav-btn-page`, wrapper).removeClass("active");
    jQuery(`.nav-btn-page[data-page=${currentPage}]`, wrapper).addClass(
      "active"
    );
    jQuery(document).scrollTop(0);
    createClickEvents();
  };

  jQuery("[type=radio],[type=checkbox]", wrapper)
    .unbind("change")
    .bind("change", () => {
      currentPage = 1;
      renderTableVisibility();
    });
  createClickEvents();
};

const initiateLeftRightScroll = (wrapper) => {
  const calculateItemWidthMap = () =>
    Object.values(
      jQuery(".post-container", wrapper).map((idx, element) =>
        jQuery(element).outerWidth(true)
      )
    );

  const numberOfItems = jQuery(".post-container", wrapper).length;
  let visibleItem = 0;
  let itemContainerWidthMap = calculateItemWidthMap();
  let leftRightScrollTimeout;

  const setMargin = (idx) => {
    const progress = Math.max(0, Math.min(100, idx / (numberOfItems - 1)));
    const marginLeft = itemContainerWidthMap
      .slice(0, idx)
      .reduce((partialSum, a) => partialSum + a, 0);

    jQuery(".post-type-list-table .post-container", wrapper).css(
      `transform`,
      `translateX(${marginLeft * -1}px)`
    );

    jQuery(".nav-btn-indicator-progress", wrapper).css(
      `width`,
      `${Math.round(progress * 100)}%`
    );
  };

  const navBack = () => {
    if (visibleItem < numberOfItems - 1) {
      visibleItem = visibleItem + 1;
      setMargin(visibleItem);
    } else {
      visibleItem = 0;
      setMargin(0);
    }
  };

  const navNext = () => {
    if (visibleItem > 0) {
      visibleItem = visibleItem - 1;
      setMargin(visibleItem);
    }
  };

  jQuery(".nav-btn-back-next .nav-btn-back", wrapper)
    .unbind("click")
    .bind("click", navNext);

  jQuery(".nav-btn-back-next .nav-btn-next", wrapper)
    .unbind("click")
    .bind("click", navBack);

  let touchstartX = 0;
  jQuery(".post-type-list-table", wrapper)[0].addEventListener(
    "touchstart",
    (e) => {
      touchstartX = e.changedTouches[0].screenX;
    }
  );

  jQuery(".post-type-list-table", wrapper)[0].addEventListener(
    "touchend",
    (e) => {
      const touchendX = e.changedTouches[0].screenX;
      if (Math.abs(touchendX - touchstartX) > 10) {
        if (touchendX < touchstartX) navBack();
        if (touchendX > touchstartX) navNext();
      }
    }
  );

  jQuery(document).on("scroll", () => {
    clearTimeout(leftRightScrollTimeout);
    leftRightScrollTimeout = setTimeout(() => {
      itemContainerWidthMap = calculateItemWidthMap();
      setMargin(visibleItem);
    }, 500);
  });
};

export const initiatePostTypeList = () => {
  jQuery(".unifon-post-type-list").each((idx, element) =>
    initiateTagFilter(element)
  );
  // LEFT/RIGHT SCROLL DISABLED
  // jQuery(
  //   ".unifon-post-type-list.design-unifon-get-posts-by-type-posts-testimonials"
  // ).each((idx, element) => initiateLeftRightScroll(element));
};
